const CardProjectFicheHrs1 = ({ className = "", title = "", hrs = 0, img = "", color = "" }) => {
	return (
		<>
			<div className={`bg-white rounded-md px-4 py-8  ${className}`}>
				<div className="w-full h-[50px]">
					<p className="font-bold text-[16px]">{title}</p>
				</div>

				<div className="flex flex-col xl:flex-row xl:justify-between">
					<div className={`w-[48px] h-[48px]`}>
						<img className="h-full w-full object-contain" src={img} alt="icon" />
					</div>
					<div className="flex items-center justify-end xl:py-4">
						<p className="text-[32px] xl:text-[36px] font-semibold" style={{ color: color }}>
							{hrs}
						</p>
					</div>
				</div>
			</div>
		</>
	);
};
export default CardProjectFicheHrs1;
